import { memo } from 'react';

interface MapTabIconProperties {
  size?: number;
}

/** Figma: map marker (18×18) */
const MapTabIcon = memo(({ size = 18 }: MapTabIconProperties) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 18 18'
    fill='none'
  >
    <g clip-path='url(#clip0_75644_18038)'>
      <path
        d='M8.9684 18.0061L8.44559 17.558C7.72486 16.9545 1.43164 11.5195 1.43164 7.54384C1.43164 3.38141 4.80597 0.00708008 8.9684 0.00708008C13.1308 0.00708008 16.5052 3.38141 16.5052 7.54384C16.5052 11.5195 10.2119 16.9545 9.4942 17.561L8.9684 18.0061ZM8.9684 1.63675C5.70755 1.64044 3.06504 4.28296 3.06134 7.54381C3.06134 10.0414 6.93317 14.0312 8.9684 15.8573C11.0037 14.0305 14.8755 10.0384 14.8755 7.54381C14.8718 4.28296 12.2293 1.64047 8.9684 1.63675Z'
        fill='black'
      />
      <path
        d='M8.96846 10.5314C7.31851 10.5314 5.98096 9.19386 5.98096 7.5439C5.98096 5.89395 7.31851 4.5564 8.96846 4.5564C10.6184 4.5564 11.956 5.89395 11.956 7.5439C11.956 9.19386 10.6185 10.5314 8.96846 10.5314ZM8.96846 6.05012C8.14349 6.05012 7.47471 6.71889 7.47471 7.54387C7.47471 8.36885 8.14349 9.03762 8.96846 9.03762C9.79344 9.03762 10.4622 8.36885 10.4622 7.54387C10.4622 6.71889 9.79348 6.05012 8.96846 6.05012Z'
        fill='black'
      />
    </g>
    <defs>
      <clipPath id='clip0_75644_18038'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </svg>
));

MapTabIcon.displayName = 'MapTabIcon';

export default MapTabIcon;
